import { Injectable, inject } from '@angular/core';

import { RoutesService, isNullOrUndefined } from '@abp/ng.core';
import { ConfigStateService } from '@abp/ng.core';
import { tap } from 'rxjs/operators';

import { createEffect } from '@nexweb/shared/effects';
import { FeatureFlagNames } from '@nexweb/shared/guards/feature-flag';

import { intraDayMarketMenuName } from './constants';

@Injectable({ providedIn: 'root' })
export class CmtMenuEffects {
  intraDayMenuEffect$ = createEffect(() => {
    const configStateService = inject(ConfigStateService);
    const routes = inject(RoutesService);

    return configStateService.getFeature$(FeatureFlagNames.intraDayMarketEnabled).pipe(
      tap((featureFlag) => {
        if (!isNullOrUndefined(featureFlag)) {
          const featureValue = JSON.parse(featureFlag);

          routes.patch(intraDayMarketMenuName, {
            invisible: !featureValue,
          });
        }
      }),
    );
  });
}
